import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Signup from './views/Signup.vue'
import ColumnDetail from './views/ColumnDetail.vue'
import CreatePost from './views/CreatePost.vue'
import PostDetail from './views/PostDetail.vue'
import store from './store'

const routerHistory = createWebHistory()
const router = createRouter({
  history: routerHistory,
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        headShow: true,
        footShow: true,
        requiredLogin: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        redirectAlreadyLogin: true,
        headShow: false,
        footShow: false
      }
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup,
      meta: {
        redirectAlreadyLogin: true,
        headShow: false,
        footShow: false
      }
    },
    {
      path: '/create',
      name: 'create',
      component: CreatePost,
      meta: { requiredLogin: true }
    },
    {
      path: '/column/:id',
      name: 'column',
      component: ColumnDetail
    },
    {
      path: '/posts/:id',
      name: 'post',
      component: PostDetail
    }
  ]
})
router.beforeEach((to, from, next) => {
  const {
    user,
    token
  } = store.state
  const {
    requiredLogin,
    redirectAlreadyLogin
  } = to.meta
  if (to.path === '/home') {
    const payload = {
      userCode: localStorage.getItem('userCode'),
      userPassWord: localStorage.getItem('userPassWord')
    }
    store.dispatch('loginAndFetch', payload).then(data => {
      console.log('data = ', data)
      // createMessage('登录成功 2秒后跳转首页', 'success')
      // setTimeout(() => {
      //   router.push('/home')
      // }, 2000)
    }).catch(e => {
      console.log(e)
    })
  }
  if (!user.isLogin) {
    if (token) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`
      store.dispatch('fetchCurrentUser').then(() => {
        if (redirectAlreadyLogin) {
          next('/home')
        } else {
          next()
        }
      }).catch(e => {
        console.error(e)
        store.commit('logout')
        next('login')
      })
    } else {
      if (requiredLogin) {
        next('login')
      } else {
        next()
      }
    }
  } else {
    if (redirectAlreadyLogin) {
      next('/home')
    } else {
      next()
    }
  }
})

export default router
